var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { getQueryParamValue, objectKeysFilter, OrderByDirection, setDiff, } from '@freelancer/datastore/core';
import { assertNever, toNumber } from '@freelancer/utils';
import { ProjectStatusApi, ProjectUpgradeOptionsApi, } from 'api-typings/projects/projects';
import { ProjectAction } from './projects.backend-model';
export function projectsBackend() {
    return {
        defaultOrder: {
            field: 'timeSubmitted',
            direction: OrderByDirection.DESC,
        },
        fetch: function (authUid, ids, query, order) { return ({
            endpoint: "projects/0.1/projects",
            params: {
                projects: __spreadArrays((ids || []).map(toNumber), getQueryParamValue(query, 'id')),
                owners: getQueryParamValue(query, 'ownerId'),
                seo_urls: getQueryParamValue(query, 'seoUrl'),
                frontend_project_statuses: getQueryParamValue(query, 'frontendProjectStatus'),
                selected_bids: 'true',
                file_details: 'true',
            },
        }); },
        push: undefined,
        set: undefined,
        update: function (authUid, document, originalDocument) {
            var payload;
            var method = 'PUT';
            var endpoint = "projects/0.1/projects/" + originalDocument.id + "/";
            if (document.status === ProjectStatusApi.CLOSED) {
                payload = {
                    action: ProjectAction.CLOSE,
                };
            }
            // Updating upgrades.
            if (document.upgrades) {
                if (payload) {
                    throw new Error("Cannot update two fields at once");
                }
                var unconvertedUpgrades = setDiff(objectKeysFilter(document.upgrades, function (x) { return x; }), 
                // refer to comments in project-view-project.backend.ts
                objectKeysFilter(originalDocument.upgrades, function (val, key) { return key !== 'extend' && val; }));
                var upgrades = unconvertedUpgrades.map(convertUpgrade);
                payload = {
                    action: ProjectAction.UPGRADE,
                    'upgrades[]': upgrades,
                };
            }
            if (payload) {
                return {
                    payload: payload,
                    endpoint: endpoint,
                    method: method,
                };
            }
            throw new Error("Cound not update any fields of the project");
        },
        remove: function (authUid, projectId, originalDocument) {
            var method = 'DELETE';
            var endpoint = "projects/0.1/projects/" + projectId;
            var payload = {};
            return {
                payload: payload,
                endpoint: endpoint,
                method: method,
            };
        },
    };
}
export function convertUpgrade(upgrade) {
    switch (upgrade) {
        case 'featured':
            return ProjectUpgradeOptionsApi.FEATURED;
        case 'assisted':
            return ProjectUpgradeOptionsApi.RECRUITER;
        case 'extend':
            return ProjectUpgradeOptionsApi.EXTEND;
        case 'urgent':
            return ProjectUpgradeOptionsApi.URGENT;
        case 'nonpublic':
            return ProjectUpgradeOptionsApi.NONPUBLIC;
        case 'fulltime':
            return ProjectUpgradeOptionsApi.FULLTIME;
        case 'listed':
            throw new Error('You cannot upgrade to listed');
        case 'NDA':
            return ProjectUpgradeOptionsApi.NDA;
        case 'ipContract':
            return ProjectUpgradeOptionsApi.IP_CONTRACT;
        case 'sealed':
            return ProjectUpgradeOptionsApi.HIDEBIDS;
        // case 'successBundle':
        //   return ProjectUpgradeOptionsApi.SUCCESS_BUNDLE;
        // case 'nonCompete':
        //   return ProjectUpgradeOptionsApi.NON_COMPETE;
        case 'projectManagement':
            return ProjectUpgradeOptionsApi.PROJECT_MANAGEMENT;
        // case 'pfOnly':
        //   return ProjectUpgradeOptionsApi.PF_ONLY;
        case 'qualified':
            throw new Error('You cannot upgrade to qualified');
        case 'unpaidRecruiter':
            throw new Error('You cannot upgrade to unpaid_recruiter');
        default:
            return assertNever(upgrade);
    }
}
